export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/underline--short.e3a34739a115b03701e8630e52a1b21b.svg";